/**
 * Left padding for a row in the folder tree, in MUI spacing units.
 *
 * Every tree surface indents by the same step per level — the folder tree, the
 * move dialog, the folder picker, the load-more row — so the step lives here
 * rather than as a repeated `level * 2` at each call site. `offset` is the
 * row's own gutter, which does differ by surface: a leaf sits further in than
 * the disclosure caret above it.
 */
export const TREE_INDENT_STEP = 2;

export const treeIndent = (level: number, offset = 0): number =>
  level * TREE_INDENT_STEP + offset;
